import { KFSearchbar, withTranslation, WithTranslation } from '@kf/ic2fx';
import React from 'react';
import { colors } from 'styles/colors';

type IKFSearchbarProps = Parameters<typeof KFSearchbar>[0] & WithTranslation;
export interface ICustomKFSearchBarProps extends IKFSearchbarProps {
  onTypingStopped?: (value: string) => void;
  typingDebounceDelay?: number;
}

const CustomKFSearchBar: React.FC<ICustomKFSearchBarProps> = ({
  t: translate,
  tReady,
  onTypingStopped,
  onChange,
  typingDebounceDelay = 500,
  ...props
}) => {
  let timer: NodeJS.Timeout;
  return (
    <KFSearchbar
      fullWidth
      onChange={(e) => {
        onChange?.(e);
        /* istanbul ignore else */
        if (onTypingStopped != null) {
          clearTimeout(timer);
          timer = setTimeout(
            () => onTypingStopped?.(e.target.value),
            typingDebounceDelay
          );
        }
      }}
      {...props}
      sx={{
        maxWidth: ({ typography }) => typography.pxToRem(400),
        '>.kfic2-searchbarInput.MuiInputBase-root ': {
          width: '100%',
          backgroundColor: colors.tertiary.white,
          px: ({ typography }) => typography.pxToRem(16),
          ...(props.InputProps?.sx as any),
          '&:focus-within, :hover, :focus': {
            borderColor: colors.primary,
            ' .kfic2-searchIcon': {
              color: colors.primary,
            },
          },
          ' .kfic2-searchIcon': {
            color: colors.type.copy,
          },
          '>.MuiInput-input': {
            p: 0,
            '::placeholder': {
              opacity: 1,
            },
            ...(props.inputProps?.sx as any),
          },
          ...props.sx,
        },
      }}
    />
  );
};

export default withTranslation()(CustomKFSearchBar);
